export default {
    path: 'posts',
    component: () => import('../Post.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách bài viết',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo bài viết',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa bài viết',
            component: () => import('../cu/CU.vue'),
        },
    ]
};